import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { ProviderId } from "@@/shared/providers/provider-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { genericId } from "@@/utilities/generic-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { BookableOptionValue } from "../../resource-reference-options/bookable-option-value";
import { bookableOptionValueZodSchema } from "../../resource-reference-options/bookable-option-value-zod-schemas";
import type { ResourceReservationId } from "../../resources/resource-reservation-id";
import { resourceReservationIdZodSchema } from "../../resources/resource-reservation-id";

type ChangeTableReservationQuantityCommand = {
    _id: string;
    _createdAt: IsoAndUnixTimestamp;
    _type: "CHANGE_TABLE_RESERVATION_QUANTITY_COMMAND";
    providerId: ProviderId;
    resourceReservationId: ResourceReservationId;

    newOptions: BookableOptionValue[];
};

type FactoryParams = Except<
    ChangeTableReservationQuantityCommand,
    "_id" | "_type" | "_createdAt"
>;
const changeTableReservationQuantityFactory = (params: FactoryParams) => {
    const command: ChangeTableReservationQuantityCommand = {
        ...params,
        _id: generateId({ prefix: "change_reservation_QUANTITY_command__" }),
        _type: "CHANGE_TABLE_RESERVATION_QUANTITY_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};
const { zodSchema: resourceIdZodSchema } = genericId("change_reservation__", {
    regexMatch: /(^change_reservation_.*$)/,
});

const changeTableReservationQuantityCommandSchema: z.ZodSchema<ChangeTableReservationQuantityCommand> =
    z.object({
        _id: resourceIdZodSchema,
        _type: z.literal("CHANGE_TABLE_RESERVATION_QUANTITY_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        resourceReservationId: resourceReservationIdZodSchema,
        providerId: providerIdZodSchema,
        newOptions: z.array(bookableOptionValueZodSchema),
    });

export {
    changeTableReservationQuantityCommandSchema,
    changeTableReservationQuantityFactory,
};
export type { ChangeTableReservationQuantityCommand };
